(function () {
    'use strict';

    angular
        .module('app.influencerManagementLog')
        .factory('influencerManagementLogService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                    return data;
                }

                function getMessage(data) {
                    if (data) {
                        return data.message;
                    }
                    return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                            var dataRes = angular.fromJson(data);

                            if (checkResponse(dataRes)) {
                                deferred.resolve(dataRes);
                            } else {
                                deferred.reject(getMessage(dataRes));
                            }
                        })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAchooUsers(loader) {
                    var url_getAchooUsers = $rootScope.apiUrl + 'admin/getAchooUsers';
                    return handleRequest(url_getAchooUsers, 'GET', null, loader);
                }

                function getInfluencerManagementLog(user_id, from_date, to_date, page_no, page_size, loader) {
                    var url_getInfluencerManagementLog = $rootScope.apiUrl + 'admin/getInfluencerManagementLog?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date + '&page_no=' + page_no + '&page_size=' + page_size;
                    return handleRequest(url_getInfluencerManagementLog, 'GET', null, loader);
                }

                function getNumberOfInfluencerManagementLog(user_id, from_date, to_date, loader) {
                    var url_getNumberOfInfluencerManagementLog = $rootScope.apiUrl + 'admin/getNumberOfInfluencerManagementLog?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date;
                    return handleRequest(url_getNumberOfInfluencerManagementLog, 'GET', null, loader);
                }

                function getNumberOfInfluencerVerifiedAndApprovalRate(user_id, from_date, to_date, loader) {
                    var url_getNumberOfInfluencerVerifiedAndApprovalRate = $rootScope.apiUrl + 'admin/getNumberOfInfluencerVerifiedAndApprovalRate?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date;
                    return handleRequest(url_getNumberOfInfluencerVerifiedAndApprovalRate, 'GET', null, loader);
                }

                function getNumberOfChannelsAdded(user_id, from_date, to_date, loader) {
                    var url_getNumberOfChannelsAdded = $rootScope.apiUrl + 'admin/getNumberOfChannelsAdded?user_id=' + user_id + '&from_date=' + from_date + '&to_date=' + to_date;
                    return handleRequest(url_getNumberOfChannelsAdded, 'GET', null, loader);
                }

                service.getAchooUsers = getAchooUsers;
                service.getInfluencerManagementLog = getInfluencerManagementLog;
                service.getNumberOfInfluencerManagementLog = getNumberOfInfluencerManagementLog;
                service.getNumberOfInfluencerVerifiedAndApprovalRate = getNumberOfInfluencerVerifiedAndApprovalRate;
                service.getNumberOfChannelsAdded = getNumberOfChannelsAdded;
                return service;
            }
        ]);
})();
